import { Component } from 'react';
import { discoverJobsRerun, gscJobsRerun } from './query';
import Loading from '../../components/Loading';

class ExtraButtons extends Component {
    constructor() {
        super();

        this.onRerunGsc = this.onRerunGsc.bind(this);
        this.onRerunDiscover = this.onRerunDiscover.bind(this);

        this.state = {
            isLoadingGsc: false,
            isLoadingDiscover: false,
        };
    }

    async onRerunGsc() {
        try {
            this.setState({
                isLoadingGsc: true,
            });
            await gscJobsRerun(this.props.current_url, this.props.csrf_token);
        } catch (err) {
            console.log(err);
        } finally {
            this.setState({
                isLoadingGsc: false,
            });
        }
    }

    async onRerunDiscover() {
        try {
            this.setState({
                isLoadingDiscover: true,
            });
            await discoverJobsRerun(this.props.current_url, this.props.csrf_token);
        } catch (err) {
            console.log(err);
        } finally {
            this.setState({
                isLoadingDiscover: false,
            });
        }
    }

    render() {
        return (
            <div className="table-additional-view">
                <div className="table-additional-view-btns">
                    <div className="table-header-extra-view-box-btns">
                        <button
                            className="table-additional-view-btn"
                            onClick={this.onRerunGsc}
                            disabled={this.state.isLoadingGsc}
                        >
                            <span style={{ marginRight: '5px' }}>Rerun Gsc</span>
                            {this.state.isLoadingGsc && <Loading onlyPreloader />}
                        </button>
                        <button
                            className="table-additional-view-btn"
                            onClick={this.onRerunDiscover}
                            disabled={this.state.isLoadingDiscover}
                        >
                            <span style={{ marginRight: '5px' }}>Rerun Discover</span>
                            {this.state.isLoadingDiscover && <Loading onlyPreloader />}
                        </button>
                    </div>
                </div>
                <div className="toggle-Invalid-items">
                    <div className="d-flex align-items-center">
                        <span
                            className={`switch-button without-text mr-10 ${
                                this.props.showInvalidItems ? 'active' : 'not-active'
                            }`}
                            onClick={this.props.toogleInvalidItems}
                            title="Delayed"
                        >
                            <span className="switch-circle" />
                        </span>
                        <span>Delayed</span>
                    </div>
                    <div className="d-flex align-items-center">
                        <span
                            className={`switch-button without-text mr-10 ${
                                this.props.showNewItems ? 'active' : 'not-active'
                            }`}
                            onClick={this.props.toogleNewItems}
                            title="Missing Items"
                        >
                            <span className="switch-circle" />
                        </span>
                        <span>Missing Items</span>
                    </div>
                </div>
            </div>
        );
    }
}

export default ExtraButtons;
